module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-5-165190c1a0af245a80e426433867e256.webp";